import React, {useEffect} from "react";
import {Link} from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import SysUserFullRenderer from './SysUserFullRendererComponent';
import * as Consts from '../constants/Consts';

function SysUserNew(props) {
    console.log('___SysUserNew___');

    useEffect(() => {
    }, []);

    const user = {
        generalSection: {
            clientId: Consts.COREVO_CLIENT_ID
        }
    }

    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Stack spacing={1} sx={{marginBottom: 2}}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to='/users'>Utilizatori</Link>
                        <Typography color="text.primary">Adauga Utilizator</Typography>
                    </Breadcrumbs>
                </Box>

                <Box>
                    <h3>Utilizator Nou - {Consts.COREVO_CLIENT_NAME}</h3>
                </Box>
                <hr/>

                <SysUserFullRenderer 
                    user={user} 
                    saveUser={props.postUser} 
                />
            </Stack>

        </Box>
        </Container>
    );

}

export default SysUserNew;